export default "__VITE_ASSET__DQfzc2wE__"